import React from "react";
import dmarcFlowLogo from './assets/img/dmarc-flow-logo.webp';
import germany from './assets/img/germany.svg';
import usa from './assets/img/usa.svg';
import {Container, Nav, Navbar, NavDropdown, Offcanvas} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {Link, useLocation, useNavigate} from 'react-router-dom';
import './TopMenu.css';
import {routes} from "./routes";
import {buildPath} from "./routes/buildPath";
import {I18nService} from "./service/i18nService";

const TopMenu = ({setActiveMenu}) => {
    const [showOffcanvas, setShowOffcanvas] = React.useState(false);
    const {t, i18n} = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    const i18nService = new I18nService();
    const currentLang = i18nService.getLanguage();

    const handleMenuClick = () => setShowOffcanvas(false);

    const changeLanguageHandler = (newLang) => {
        // if (newLang === currentLang) return;

        const pathSegments = location.pathname.split('/');
        const currentSlug = pathSegments.slice(2).join('/');

        const routeKey = Object.keys(routes).find(
            (key) => routes[key][currentLang] === currentSlug
        );

        if (!routeKey) {
            // fallback: just go to homepage in new lang
            i18n.changeLanguage(newLang);
            // document.documentElement.lang = newLang;
            navigate(`/${newLang}`);
            return;
        }

        const translatedPath =
            routes[routeKey][newLang]
                ? `/${newLang}/${routes[routeKey][newLang]}`
                : `/${newLang}`;

        i18n.changeLanguage(newLang);
        // document.documentElement.lang = newLang;
        navigate(translatedPath);
    };


    return (
        <Navbar expand="lg" className="bg-body-tertiary" sticky="top">

            <Container>
                <Navbar.Brand href="/">
                    <img
                        alt="DMARC Flow Logo"
                        src={dmarcFlowLogo}
                        width="60"
                        height="60"
                        className="d-inline-block align-top"
                    />
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="offcanvasNavbar" onClick={() => setShowOffcanvas(true)}/>

                <Navbar.Offcanvas
                    id="offcanvasNavbar"
                    aria-labelledby="offcanvasNavbarLabel"
                    placement="end"
                    show={showOffcanvas}
                    onHide={() => setShowOffcanvas(false)}
                >
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title id="offcanvasNavbarLabel">Menu</Offcanvas.Title>
                    </Offcanvas.Header>

                    <Offcanvas.Body>
                        <Nav className="me-auto">
                            <NavDropdown title={
                                <span className="d-inline-flex align-items-center gap-2">
                                    <i className="bi bi-shield-lock" style={{fontSize: "1.2rem"}}></i>
                                    {t("topMenu.dmarc.title")}
                                </span>
                            } id={"dmarc-dropdown"} className="dmarc-dropdown">
                                <NavDropdown.Item as={Link}
                                                  to={buildPath("dmarcRecordChecker", currentLang)}
                                                  onClick={handleMenuClick}
                                >{t("topMenu.dmarc.subMenu.one")}</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to={buildPath("dmarcRecordGenerator", currentLang)}
                                                  onClick={handleMenuClick}>
                                    {t("topMenu.dmarc.subMenu.two")}
                                </NavDropdown.Item>
                                <NavDropdown.Item as={Link}
                                                  to={buildPath("enterpriseEmailProtectionWithDmarc", currentLang)}
                                                  onClick={handleMenuClick}>
                                    {t("topMenu.dmarc.subMenu.three")}
                                </NavDropdown.Item>
                            </NavDropdown>

                            <NavDropdown title={
                                <span className="d-inline-flex align-items-center gap-2">
                                    <i className="bi bi-shield-check" style={{fontSize: "1.2rem"}}></i>

                                    {t("topMenu.spf.title")}
                                </span>
                            } id={"spf-dropdown"} className="dmarc-dropdown">
                                <NavDropdown.Item as={Link} to={buildPath("spfRecordChecker", currentLang)}
                                                  onClick={handleMenuClick}>
                                    {t("topMenu.spf.subMenu.one")}
                                </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to={buildPath("spfRecordGenerator", currentLang)}
                                                  onClick={handleMenuClick}>
                                    {t("topMenu.spf.subMenu.two")}
                                </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to={buildPath("spfProtectionWithSpf", currentLang)}
                                                  onClick={handleMenuClick}>
                                    {t("topMenu.spf.subMenu.three")}
                                </NavDropdown.Item>
                            </NavDropdown>

                            <NavDropdown title={
                                <span className="d-inline-flex align-items-center gap-2">
                                    <i className="bi bi-patch-check" style={{fontSize: "1.2rem"}}></i>
                                    {t("topMenu.dkim.title")}
                                </span>
                            } id={"dkim-dropdown"} className="dmarc-dropdown">
                                <NavDropdown.Item as={Link} to={buildPath("dkimRecordChecker", currentLang)}
                                                  onClick={handleMenuClick}>
                                    {t("topMenu.spf.subMenu.one")}
                                </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to={buildPath("dkimRecordGenerator", currentLang)}
                                                  onClick={handleMenuClick}>
                                    {t("topMenu.spf.subMenu.two")}
                                </NavDropdown.Item>
                            </NavDropdown>

                            <NavDropdown title={
                                <span className="d-inline-flex align-items-center gap-2">
                                    <i className="bi bi-tag" style={{fontSize: "1.2rem"}}></i>

                                    {t("topMenu.bimi.title")}
                                </span>
                            } id={"bimi-dropdown"} className="dmarc-dropdown">
                                <NavDropdown.Item as={Link} to={buildPath("bimiRecordChecker", currentLang)}
                                                  onClick={handleMenuClick}>
                                    {t("topMenu.bimi.subMenu.one")}
                                </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to={buildPath("bimiRecordGenerator", currentLang)}
                                                  onClick={handleMenuClick}>
                                    {t("topMenu.bimi.subMenu.two")}
                                </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to={buildPath("bimiEnterpriseBimiSolutions", currentLang)}
                                                  onClick={handleMenuClick}>
                                    {t("topMenu.bimi.subMenu.three")}
                                </NavDropdown.Item>
                            </NavDropdown>

                            <Nav.Link as={Link} to={buildPath("pricing", currentLang)}>
                                <span className="d-inline-flex align-items-center gap-2">
                                    <i className="bi bi-sliders2-vertical" style={{fontSize: "1.2rem"}}></i>
                                    {t("topMenu.pricing.title")}
                                </span>
                            </Nav.Link>
                        </Nav>

                        <Nav className="flex-row align-items-center mt-3 mt-lg-0 justify-content-center">
                            <img
                                alt="Germany"
                                src={germany}
                                width="30"
                                height="15"
                                className="d-inline-block align-top clickable img-fluid rounded shadow me-2"
                                onClick={() => changeLanguageHandler('de')}
                            />
                            <img
                                alt="USA"
                                src={usa}
                                width="30"
                                height="15"
                                className="d-inline-block align-top clickable img-fluid rounded shadow"
                                onClick={() => changeLanguageHandler('en')}
                            />
                        </Nav>

                        <Nav className="align-items-center mt-3 mt-lg-0">
                            <Nav.Link
                                href="https://app.dmarcflow.com"
                                className="border rounded ms-2"
                            >
                                {t("topMenu.login.title")}
                            </Nav.Link>
                        </Nav>
                    </Offcanvas.Body>
                </Navbar.Offcanvas>
            </Container>
        </Navbar>
    );
};

export default TopMenu;
